import { AppError } from "./AppError";

//

export class TelegramError extends AppError {
  constructor(message: string) {
    super(message, {
      isOperational: false,
      statusCode: 500,
    });
    this.name = "TelegramError";
    Error.captureStackTrace(this, TelegramError);
  }
}
